<script setup>
import { ref } from 'vue';
import {
  decimalToFractional,
  decimalToAmerican,
  fractionalToDecimal,
  americanToDecimal,
} from '@/services/oddsConverterServiceFunctions';

const decimalOdds = ref(2.0);
const fractionalOdds = ref('1/1');
const americanOdds = ref(100);

const convertFromDecimal = () => {
  fractionalOdds.value = decimalToFractional(decimalOdds.value);
  americanOdds.value = decimalToAmerican(decimalOdds.value);
};

const convertFromFractional = () => {
  const decimal = fractionalToDecimal(fractionalOdds.value);
  decimalOdds.value = parseFloat(decimal.toFixed(4));
  americanOdds.value = decimalToAmerican(decimal);
};

const convertFromAmerican = () => {
  const decimal = americanToDecimal(americanOdds.value);
  decimalOdds.value = parseFloat(decimal.toFixed(4));
  fractionalOdds.value = decimalToFractional(decimal);
};
</script>

<template>
  <div class="odds-converter">
    <div class="input-group">
      <label>Decimal Odds:</label>
      <input v-model.number="decimalOdds" @input="convertFromDecimal" />
    </div>
    <div class="input-group">
      <label>Fractional Odds:</label>
      <input v-model="fractionalOdds" @input="convertFromFractional" />
    </div>
    <div class="input-group">
      <label>American Odds:</label>
      <input v-model.number="americanOdds" @input="convertFromAmerican" />
    </div>
  </div>
</template>

<style scoped>
.odds-converter {
  max-width: 576px;
  margin: 0 auto;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

h1 {
  text-align: center;
  margin-bottom: 20px;
}

.input-group {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}

input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

input:focus {
  border-color: #007BFF;
  outline: none;
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
}
</style>



